var WDN = WDN || {};

if (typeof WDN.SearchDrawer === "undefined") {
  WDN.SearchDrawer = (function () {
    var init, bind, store_header_height;
    var assign_nodes;

    var nodes = {};

    // Depends on
    var SectionRenderer = WDN.SectionRenderer;
    var CSSVariable = WDN.CSSVariable;

    assign_nodes = function () {
      var drawer = document.querySelector("wdn-drawer[data-id='search']");
      if (!drawer) return;
      nodes = {
        drawer: drawer,
        search_element: drawer.querySelector("wdn-search"),
        search_header: drawer.querySelector("[data-search-header]"),
      };
    };

    store_header_height = function () {
      if (!nodes.search_header) return;
      CSSVariable.set({
        name: "--search-header-height",
        value: nodes.search_header.getBoundingClientRect().height + "px",
      });
    };

    bind = function () {
      var drawerOpener = document.querySelector('wdn-drawer-open[data-id="search"]');
      if (!drawerOpener) return;
      drawerOpener.addEventListener("click", function () {
        var input = document.querySelector("wdn-drawer [data-search-input]");
        if (!input) return;
        input.focus();
      });
    };

    init = function () {
      assign_nodes();
      nodes.search_element.init();
      if (!nodes.drawer) return;
      store_header_height();

      window.addEventListener("window:resize", store_header_height);
    };

    // Init
    var renderer = new SectionRenderer({
      selectors: {
        trigger: "wdn-drawer-open[data-id='search']",
        output: "[data-searchdrawer-content]",
      },
      sections: ["async-search-drawer"],
      events: ["mouseover", "click"],
      callback: init,
    });

    // Listen for Opener click
    bind();

    // Load styles when layout is about to be rendered
    renderer.onInteraction = function () {
      WDN.StylesheetLoader.load(".searchdrawer-style");
    };

    return {};
  })();
}
